import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonSection() {
  return <section className="w-full bg-gradient-to-b from-gray-50 to-white py-16 md:py-24" data-id="element-122">
      <div className="max-w-5xl mx-auto px-6" data-id="element-123">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-124">
          ¿Qué hace diferente a META ADS DESDE CERO?
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12" data-id="element-125">
          No es otro curso grabado más
        </p>

        <div className="overflow-x-auto" data-id="element-126">
          <table className="w-full bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-127">
            <thead data-id="element-128">
              <tr className="bg-gray-100" data-id="element-129">
                <th className="px-6 py-4 text-left text-gray-600 font-semibold" data-id="element-130">
                  Característica
                </th>
                <th className="px-6 py-4 text-center text-gray-600 font-semibold" data-id="element-131">
                  Cursos grabados genéricos
                </th>
                <th className="px-6 py-4 text-center bg-blue-50 text-[#0866FF] font-bold" data-id="element-132">
                  META ADS DESDE CERO
                </th>
              </tr>
            </thead>
            <tbody data-id="element-133">
              <tr className="border-t border-gray-200" data-id="element-134">
                <td className="px-6 py-4 text-gray-700 font-medium" data-id="element-135">Formato</td>
                <td className="px-6 py-4 text-center" data-id="element-136">
                  <div className="flex items-center justify-center gap-2 text-red-600" data-id="element-137">
                    <XIcon className="w-5 h-5" data-id="element-138" />
                    <span data-id="element-139">Videos largos que ves una vez y olvidas</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-center bg-blue-50" data-id="element-140">
                  <div className="flex items-center justify-center gap-2 text-green-600" data-id="element-141">
                    <CheckIcon className="w-5 h-5" data-id="element-142" />
                    <span className="font-semibold" data-id="element-143">
                      Clases en vivo, con espacio para preguntar
                    </span>
                  </div>
                </td>
              </tr>
              <tr className="border-t border-gray-200" data-id="element-144">
                <td className="px-6 py-4 text-gray-700 font-medium" data-id="element-145">Nivel</td>
                <td className="px-6 py-4 text-center" data-id="element-146">
                  <div className="flex items-center justify-center gap-2 text-red-600" data-id="element-147">
                    <XIcon className="w-5 h-5" data-id="element-148" />
                    <span data-id="element-149">Avanzan rápido, sin pensar en principiantes</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-center bg-blue-50" data-id="element-150">
                  <div className="flex items-center justify-center gap-2 text-green-600" data-id="element-151">
                    <CheckIcon className="w-5 h-5" data-id="element-152" />
                    <span className="font-semibold" data-id="element-153">
                      Explicaciones diseñadas específicamente para principiantes
                    </span>
                  </div>
                </td>
              </tr>
              <tr className="border-t border-gray-200" data-id="element-154">
                <td className="px-6 py-4 text-gray-700 font-medium" data-id="element-155">
                  Seguimiento
                </td>
                <td className="px-6 py-4 text-center" data-id="element-156">
                  <div className="flex items-center justify-center gap-2 text-red-600" data-id="element-157">
                    <XIcon className="w-5 h-5" data-id="element-158" />
                    <span data-id="element-159">Nadie revisa si te estás perdiendo</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-center bg-blue-50" data-id="element-160">
                  <div className="flex items-center justify-center gap-2 text-green-600" data-id="element-161">
                    <CheckIcon className="w-5 h-5" data-id="element-162" />
                    <span className="font-semibold" data-id="element-163">
                      Compartimos pantalla y ves todo paso a paso
                    </span>
                  </div>
                </td>
              </tr>
              <tr className="border-t border-gray-200" data-id="element-164">
                <td className="px-6 py-4 text-gray-700 font-medium" data-id="element-165">Soporte</td>
                <td className="px-6 py-4 text-center" data-id="element-166">
                  <div className="flex items-center justify-center gap-2 text-red-600" data-id="element-167">
                    <XIcon className="w-5 h-5" data-id="element-168" />
                    <span data-id="element-169">Te dejan solo cuando abres tu cuenta</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-center bg-blue-50" data-id="element-170">
                  <div className="flex items-center justify-center gap-2 text-green-600" data-id="element-171">
                    <CheckIcon className="w-5 h-5" data-id="element-172" />
                    <span className="font-semibold" data-id="element-173">
                      Soporte y grabaciones para que puedas repasar
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}